export enum DigitalShareSectionEnum {
  HH_CHARACTERISTICS = "Household Characteristics",
  HH_COMPOSITION = "Household Composition",
  TRADE_AREA = "Trade Area",
  VOLUME = "Volume",
  VISITOR_BEHAVIORS = "Visitor Behaviors",
  IMAGE_GALLERY = "Image Gallery",
  LOCATIONS_ANALYZED = "Locations Analyzed",
  KEY_METRICS = "Key Metrics",
  PSYCHOGRAPHIC_PROFILE = "Psychographic Profile",
  BRAND_COMPARISON = "Brand Comparison",
}
